import { render, staticRenderFns } from "./crateInventory.vue?vue&type=template&id=6e79f6b6"
import script from "./crateInventory.vue?vue&type=script&lang=js"
export * from "./crateInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e79f6b6')) {
      api.createRecord('6e79f6b6', component.options)
    } else {
      api.reload('6e79f6b6', component.options)
    }
    module.hot.accept("./crateInventory.vue?vue&type=template&id=6e79f6b6", function () {
      api.rerender('6e79f6b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Production/crateInventory.vue"
export default component.exports